<div class="fdx-c-modal my-3" style="overflow-y:auto; overflow-x: hidden!important;">
    <div class="fdx-c-modal__main fdx-c-modal__main--">

        <div class="fdx-c-modal__description">
            <h3 class="fdx-u-fontweight--bold fdx-u-align--center my-2">
                {{"COMMON.CommonUploadTitle_Documentuploadfor" | translate: {Default: "Document Upload for"} }} 
                {{labelHeader}}
            </h3>
            <div class="richtext parbase section">
                <div class="fxg-rte fxg-rte--align-center fxg-rte--mobile-align-center" style="color:default;"
                    data-emptytext="Rich Text">
                    <p style="margin-bottom:0;"><span class="italic">
                        {{"COMMON.CommonUploadPara_Maxfilesize" | translate: {Default: "Max file size:"} }} 
                        {{allowedFileSize}}, 
                        {{"COMMON.CommonUploadPara_Fileformatpdfjpgjpeg" | translate: {Default: "File format: PDF, JPG, JPEG"} }}
                    </span></p>
                    <p style="margin : 0; padding-top:0;"><span class="italic">
                        {{"COMMON.CommonUploadPara_Youcanuploadmultiplefilesupto30" | translate: {Default: "You can upload multiple files up to 30"} }}
                    </span></p>
                </div>
            </div>
        </div>

        <hr class="fdx-c-line  fdx-c-line--default fdx-c-line--spaced">

        <form [formGroup]="documentGrp" (ngSubmit)="onSubmit(documentGrp.value)" #uploadDocumentsForm="ngForm"
            ngNativeValidate>
            <div class="box box-solid box-primary">
                <div class="box-body" formArrayName="items">

                    <div class="row" style="max-height:60vh!important; overflow-y: auto;">
                        <div class="col-sm-12">

                            <div *ngFor="let item of documentGrp.get('items')['controls'];index as i">
                                <div [formGroupName]="i">
                                    <table id="tbl-upload" class="fdx-c-table fdx-c-table--condensed" style="table-layout: fixed;">
                                        <thead class="fdx-c-table__thead">
                                            <tr *ngIf="i==0">
                                                <th class="fdx-c-table__thead__th" scope="col">
                                                    <span class="fdx-c-content">
                                                        {{"COMMON.CommonUploadTablehead_Documenttype" | translate: {Default: "Document Type"} }}
                                                    </span>
                                                </th>
                                                <th class="fdx-c-table__thead__th" scope="col">
                                                    <span class="fdx-c-content">
                                                        {{"COMMON.CommonUploadTablehead_Documentfile" | translate: {Default: "Document File"} }}
                                                    </span>
                                                </th>
                                                <th class="fdx-c-table__thead__th" scope="col">
                                                    <span class="fdx-c-content">
                                                        {{"COMMON.CommonUploadTablehead_Filename" | translate: {Default: "File Name"} }}
                                                    </span>
                                                </th>
                                                <th class="fdx-c-table__thead__th" scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style="width: 25%;"
                                                    class="fdx-c-table__tbody__td fdx-u-pt--0 fdx-u-pb--0 fdx-c-table__tbody__td--fit-content">
                                                    <div class="fdx-o-grid__item fdx-o-grid__item--12">
                                                        <div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--has-value"
                                                            [ngClass]="{
                                                            'fdx-c-form-group--is-invalid':
                                                              !item.get('doc_type').valid &&
                                                              item.get('doc_type').touched &&
                                                              item.get('doc_type').hasError('required'),
                                                          'fdx-c-form-group--has-value':
                                                            item.get('doc_type').value !== null && item.get('doc_type').value !== ''
                                                          }">
                                                            <span class="fdx-c-form-group__item" [ngClass]="{
                                                              'fdx-c-form-group--is-invalid':
                                                                !item.get('doc_type').valid &&
                                                                item.get('doc_type').touched &&
                                                                item.get('doc_type').hasError('required'),
                                                            'fdx-c-form-group--has-value':
                                                              item.get('doc_type').value !== null && item.get('doc_type').value !== ''
                                                            }">
                                                                <select id="doc_type" formControlName="doc_type"
                                                                    class="fdx-c-form-group__select"
                                                                    (change)="selectChangeHandler($event, i)">
                                                                    <option label="{{ 'APP.AppOption_Select' | translate: {Default: 'Select'} }}" value="" selected="">
                                                                        {{"APP.AppOption_Select" | translate: {Default: "Select"} }}
                                                                    </option>
                                                                    <option *ngFor="let units of docType"
                                                                        [value]="units.lookupCode">
                                                                        {{ units.lookupCodeDescription }}
                                                                    </option>
                                                                </select>
                                                                <div class="fdx-c-form-group__icon">
                                                                    <svg class="fdx-c-icon" aria-hidden="true"
                                                                        focusable="false" role="presentation">
                                                                        <use xlink:href="#chevron"></use>
                                                                    </svg>
                                                                </div>
                                                                <label class="fdx-c-form-group__label fdx-c-form-group__label__trunc"
                                                                    for="doc_type">
																	<span class="fdx-c-content">
                                                                        {{"COMMON.CommonUploadInput_Documenttype" | translate: {Default: "Document Type"} }}
                                                                    </span>
																</label>
                                                            </span>
                                                            <span class="fdx-c-eyebrow  fdx-c-eyebrow--super-small">
                                                                <span class="fdx-c-content">
                                                                    {{"COMMON.CommonUploadPara_Asuffix" | translate: {Default: "A suffix"} }}
                                                                </span> '{{documentPrefix[i]}}' <span class="fdx-c-content">
                                                                    {{"COMMON.CommonUploadPara_Willbeappendedtotheselectedfilename" | translate: {Default: "will be appended to the selected filename"} }}
                                                                </span>
                                                            </span>
                                                            <div role="alert"
                                                                class="fdx-c-form-group__message fdx-c-form-message--error"
                                                                *ngIf="!item.get('doc_type').valid && item.get('doc_type').touched && item.get('doc_type').hasError('required')">
                                                                {{"COMMON.CommonUploadErrmsg_Pleaseselectdocumenttype" | translate: {Default: "Please select Document Type"} }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td style="width: 20%;"
                                                    class="fdx-c-table__tbody__td fdx-c-table__tbody__td--fit-content">
                                                    <div class="fdx-c-file" >
                                                        <input class="fdx-c-file__input" type="file" id="{{ 'file-upload-' + i }}"
                                                            name="avatar"
                                                            accept="application/pdf, image/jpg, image/jpeg"
                                                            title="Browse Document"
                                                            (change)="fileSelectionEvent($event,i)" style="display: none;">
                                                        <label for="{{ 'file-upload-' + i }}" class="custom-file-upload fdx-c-button fdx-c-button--secondary-outline fxg-margin-right fxg-mb-10 fxg-margin-top-md">
                                                            <img style="width: 30px;" src="./assets/svg/cloud-upload-svgrepo-com.svg" class="upload-cloud-img"> 
                                                            {{"BULKUPLOAD.BulkuploadformInput_Choosefile" | translate: {Default: "Choose file"} }}
                                                        </label>
                                                        <div class="fdx-c-form-group__label__trunc">
                                                            {{uploadedFileName[i]}}
                                                        </div>
                                                    </div>
                                                    <div class="fdx-c-eyebrow  fdx-c-eyebrow--super-small mt-4">
                                                        
                                                    </div>
                                                </td>

                                                <td style="width: 40%;"
                                                    class="fdx-c-table__tbody__td fdx-u-pt--0 fdx-u-pb--0 fdx-c-table__tbody__td--fit-content">
                                                    <div class="fdx-o-grid__item--12">
                                                        <div
                                                            class="fdx-c-form-group fdx-c-form-group--float-label fdx-c-form-group--has-value" [ngClass]="{
                                                                'fdx-c-form-group--is-invalid':
                                                                  !item.get('doc_description').valid &&
                                                                  item.get('doc_description').touched &&
                                                                  item.get('doc_description').hasError('required')}">
                                                            <div class="fdx-c-form-group__item" >
                                                                <input #input type="text" class="fdx-c-form-group__input"
                                                                    name="doc_description"
                                                                    formControlName="doc_description" maxlength="100"
                                                                    placeholder='{{"COMMON.CommonUploadErrmsg_Enterdocumentdescription" | translate: {Default: "Enter Document Description"} }}'>
                                                                <label
                                                                    class="fdx-c-form-group__label fdx-c-form-group__label__trunc fdx-c-form-group__label--dark">
                                                                    <span class="fdx-c-content">
                                                                        {{"COMMON.CommonUploadInput_Filename" | translate: {Default: "File Name"} }}
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert"
                                                                class="fdx-c-form-group__message fdx-c-form-message--error"
                                                                *ngIf="
                                                                    !item.get('doc_description').valid &&
                                                                    item.get('doc_description').touched &&
                                                                    item.get('doc_description').hasError('required')
                                                                " translate>
                                                                {{"COMMON.CommonUploadErrmsg_Pleaseprovideadocumentdescription" | translate: {Default: "Please provide a document description"} }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="fdx-c-eyebrow  fdx-c-eyebrow--super-small mt-4">
                                                    </div>
                                                </td>

                                                <td style="width: 15%;" class="mx-auto my-auto"
                                                    style="text-align: center!important;" *ngIf=" i!=0 ">
                                                    <button type="button"
                                                        class="fdx-c-button fdx-c-button--icon fdx-c-button--icon-large text-align-center"
                                                        aria-label="Delete row" (click)="removeItem(i)">
                                                        <svg class="fdx-c-icon fdx-c-close--icon-large"
                                                            aria-hidden="true" focusable="false" role="presentation">
                                                            <use xlink:href="#cross-circle"></use>
                                                        </svg>
                                                    </button>
                                                </td>
                                            </tr>
                                            <div class="fdx-o-grid fdx-u-mt--2 fdx-u-pt--2 fdx-o-grid__item--12"></div>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="pull-right">
                                <button type="button"
                                    class="fdx-c-button fdx-c-button--text fdx-c-button--condensed fdx-u-pb--6"
                                    (click)="addItem()" *ngIf="items.length < 30">
                                    <span aria-hidden="true"
                                        class="fdx-u-text--bold fdx-u-font-size--default fdx-u-pr--1">+</span>
                                        {{"COMMON.CommonUploadButton_Addanotherdocument" | translate: {Default: "Add another document"} }}
                                </button>
                            </div>
                        </div>
                        <!--./col-->
                    </div>
                    <!--./row-->
                </div>
            </div>
        </form>

        <!-- Action Buttons -->
        <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small my-4">
            <div class="row ml-auto">
                <button class="fdx-c-button fdx-c-button--text fxg-margin-right" (click)="onClose('close')">
                    {{"APP.AppButton_Cancel" | translate: {Default: "CANCEL"} }}
                </button>
                <!-- <button class="fdx-c-button fdx-c-button--primary fxg-margin-right" [disabled]="!showSaveBtn"
                    (click)="deleteFile()">
                    Delete
                </button> -->
                <button [hidden]="showLoadingButtonSave" class="fdx-c-button fdx-c-button--primary fxg-margin-right" (click)="saveUpload()">
                    {{"APP.AppButton_Save" | translate: {Default: "SAVE"} }}
                </button>
                <button [hidden]="!showLoadingButtonSave"
                    class="fdx-c-button fdx-c-button--primary fdx-c-button--min-width fdx-c-button--loading"
                    aria-label="Continue" disabled="disabled">
                    <span class="fdx-c-button__title" hidden>
                        {{"APP.AppButton_Continue" | translate: {Default: "Continue"} }}
                    </span>
                    <span class="fdx-c-button__loading">
                        <div class="fdx-c-loading-indicator  fdx-c-loading-indicator--white">
                            <div class="fdx-c-loading-indicator__part"></div>
                            <div class="fdx-c-loading-indicator__part"></div>
                            <div class="fdx-c-loading-indicator__part"></div>
                            <div class="fdx-c-loading-indicator__part"></div>
                        </div>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>


<app-successmodal *ngIf="displaySuccessModal" [modalDialogBodyContent]="successContent" modalDialogType="MEDIUM"
    (closeSuccessModalDialogEvent)="handleCloseEventForSuccess()">
</app-successmodal>

<app-failure-modal *ngIf="displayFailureNotification" [modalDialogBodyContent]="errorMessage" modalDialogType='MEDIUM'
    (closeSuccessModalDialogEvent)="handleCloseErrorEvent()">
</app-failure-modal>